import {Pipe, PipeTransform} from '@angular/core';
import {ScheduleTypeInternal} from "../../core/interfaces/core.types";

@Pipe({
  standalone: true,
  name: 'dynamicClassPipe'
})
export class DynamicClassPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    switch (value) {
      case ScheduleTypeInternal.whatsapp:
        return 'bg-green-500';
      case ScheduleTypeInternal.call_me_back:
        return 'bg-blue-500';
      case ScheduleTypeInternal.call_us:
        return 'bg-cyan-500';
      case ScheduleTypeInternal.bookings:
        return 'bg-indigo-500';
      case ScheduleTypeInternal.none:
        return 'bg-indigo-500';
      default:
        return 'bg-indigo-500';
    }
  }

}
